// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
// ----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { UniqueThemeDto, PublishedThemeConfig } from "../../types";
import type { UseApiFetchOptions, UseApiFetchResponse } from "../../composables/useApiFetch";
import type { NitroFetchOptions } from "nitropack";
import type { Ref, MaybeRef } from "vue";
import {
    $apiFetch,
    computed,
    unref,
    useApiFetch,
    useFetchDependencies
} from "#imports";

export function useThemeResource () {

    /**
     * Handles the HTTP GET request to list all available themes.
     * @return An ActionResult`1 representing the response, containing a list of UniqueThemeDto if available.
     */
    function listThemes(
        
    ) : UseApiFetchResponse<UniqueThemeDto[]> {
        const computedUrl = computed( () => {
          let url_ = "/api/themes";

        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<UniqueThemeDto[]> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<UniqueThemeDto[]>( computedUrl, options_ );
    }

    /**
     * Get the config for the given theme
     * @param key The theme key
     * @return The config for the given theme.
     */
    function getThemeConfig(
        key: MaybeRef<string>
    ) : UseApiFetchResponse<PublishedThemeConfig> {
        const computedUrl = computed( () => {
          let url_ = "/api/themes/{key}/config";

        const keyUnref = unref( key );
        if (keyUnref === undefined || keyUnref === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + keyUnref));

        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<PublishedThemeConfig> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<PublishedThemeConfig>( computedUrl, options_ );
    }

    return {
        listThemes,
        getThemeConfig,
    }
}


export function $themeResource () {

    const dependencies_ = useFetchDependencies();

    /**
     * Handles the HTTP GET request to list all available themes.
     * @return An ActionResult`1 representing the response, containing a list of UniqueThemeDto if available.
     */
    function listThemes(
        
    ) {
        let url_ = "/api/themes";

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<UniqueThemeDto[]>( url_, options_, dependencies_ );
    }

    /**
     * Get the config for the given theme
     * @param key The theme key
     * @return The config for the given theme.
     */
    function getThemeConfig(
        key: string
    ) {
        let url_ = "/api/themes/{key}/config";

        const keyUnref = unref( key );
        if (keyUnref === undefined || keyUnref === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + keyUnref));

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<PublishedThemeConfig>( url_, options_, dependencies_ );
    }

    return {
        listThemes,
        getThemeConfig,
    }
}